import {
  isAppLanguage,
  type AppLanguage,
} from '@/shared/lib/appLanguageSupports';

import {SESSION_LANGUAGE} from './serve/consts';
import {get, set} from './serve/sessionStorage';

export function setSessionLanguage(language: AppLanguage): void {
  set(SESSION_LANGUAGE, language);
}

export function getSessionLanguage(): AppLanguage | undefined {
  const language = get<string>(SESSION_LANGUAGE);

  return language && isAppLanguage(language) ? language : undefined;
}
